module.exports = __webpack_public_path__ + "static/media/editor-icon-ordered-list-active.90851b94.svg";